// extracted by mini-css-extract-plugin
module.exports = {"direction":"direction-2-Vxk","count":"count-2fpFe","icon":"icon-3W8QT"};